import type { Directive } from 'vue';

const observers = new WeakMap<HTMLElement, IntersectionObserver>();

export const lazyBackground: Directive<HTMLElement, string> = {
  mounted(element, binding) {
    if (!binding.value) return;

    const observer = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) {
        return;
      }

      // eslint-disable-next-line no-param-reassign
      element.style.backgroundImage = `url("${binding.value}")`;
      observer.disconnect();
    });

    observers.set(element, observer);

    observer.observe(element);
  },

  beforeUnmount(element) {
    if (!observers) return;
    observers.get(element)?.disconnect();
    observers.delete(element);
  },
};
